<template>
  <div class="app-layout__header">
    <slot>
      <app-header primary full>
        <app-navbar slot="left"></app-navbar>
        <app-setting slot="right"></app-setting>
      </app-header>
    </slot>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppNavbar from '@/components/AppNavbar'
import AppSetting from '@/components/AppSetting'

export default {
  name: 'AppLayoutHeader',
  components: {
    AppHeader,
    AppNavbar,
    AppSetting
  }
}
</script>
